<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-30 10:37:57
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-07 15:55:39
 * @FilePath: \miniproweb\src\views\DocPage\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="DocPageBody">
    <div class="docTitle">{{name}}</div>
    <van-cell title="测试文章" is-link :url="item.url" v-for="item in list" :label="item.extension">
      <template #title>
        <span class="custom-title">{{item.name}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      name: ""
    };
  },
  created() {
    console.log(JSON.parse(this.$route.params.id));
    this.getTypeList(JSON.parse(this.$route.params.id));
    this.name = JSON.parse(this.$route.params.id).name;
  },
  methods: {
    getTypeList(data) {
      this.$axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/getFileUrlInfo",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: data.value
        }
      }).then(res => {
        console.log(res.data);
        this.list = res.data;
      });
    }
  }
};
</script>

<style>
.DocPageBody {
  height: 100vh;
  width: 100vw;
  padding: 15px 0;
}
.docTitle {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: rgb(0, 140, 255);
}
</style>